import './AppFormLayout.less'

import {
	AppFormBlock as AppFormBlockProps,
	AppFormItem as AppFormItemProps,
	AppFormLayout as AppFormLayoutProps,
} from 'api'
import React, { Component, Fragment } from 'react'

import { AppFormItem, AppFormTabs } from '.'
import { AppFormBlock } from './AppFormBlock'
import { AppFormMenu } from './AppFormMenu'

export interface AppFormLayoutContext {
	formData: any
	formConfig: AppFormLayoutProps
	onChange?: (field: string, value: any) => void
	onSearch?: (title?: string, URL?: string, parameter?: string, field?: string) => void
	action?: (type: string, context: AppFormLayoutContext) => void
	setOnSearch?: (data: any[]) => void
	tabId?: number
}
export const AppFormLayoutContext = React.createContext<AppFormLayoutContext>({} as AppFormLayoutContext)

interface Props extends AppFormLayoutProps {
	formData?: any
	formConfig?: AppFormLayoutProps
	className?: string
	style?: React.CSSProperties
}

export default class extends Component<Props> {
	state = {
		formData: this.props.formData,
		formConfig: {} as AppFormLayoutProps,
		tabId: -1,
	}

	componentDidMount = () => {
		let formConfig = this.props.formConfig
		let tabId = formConfig && formConfig.appFormTabs && formConfig.appFormTabs.defaultTabId
		this.setState({ formConfig, tabId })
	}

	onChange = (field: string, value: any) => {
		let { formData } = this.state
		formData[field] = value
		this.setState({ formData })
	}

	chgTab = (tabId: number) => {
		this.setState({ tabId })
	}
	renderAppFormTabs = () => {
		let { formConfig, tabId } = this.state
		if (!formConfig.appFormTabs) {
			return <Fragment />
		}
		let tabList = formConfig.appFormTabs.tabList || []
		return <AppFormTabs {...formConfig.appFormTabs} tabList={tabList} onChange={this.chgTab}></AppFormTabs>
	}

	renderAppForm = () => {
		let { formConfig, tabId, formData } = this.state
		let appFormTab =
			formConfig &&
			formConfig.appFormTabs &&
			formConfig.appFormTabs.appFormTabList &&
			formConfig.appFormTabs.appFormTabList.find(e => e.tabId === tabId)
		// if (!appFormTab || !appFormTab.appForm) return <Fragment />
		return (
			<div className="app-form">
				{appFormTab.appFormBlockList
					.filter(appFormBlockProps => !appFormBlockProps.isHidden)
					.map((appFormBlockProps: AppFormBlockProps, index: number) => {
						return (
							<AppFormBlock key={index} {...appFormBlockProps}>
								{appFormBlockProps.appFormItemList &&
									appFormBlockProps.appFormItemList
										.filter(appFormItemProps => !appFormItemProps.isHidden)
										.map((appFormItemProps: AppFormItemProps) => {
											return (
												<AppFormItem
													key={appFormItemProps.field}
													{...appFormItemProps}
													value={
														formData[appFormItemProps.field] ||
														appFormItemProps.defaultValue
													}
												/>
											)
										})}
							</AppFormBlock>
						)
					})}
			</div>
		)
	}

	customer = (a: any) => {
		// const test = require('/utils/index')
		// console.log('test', require('/utils/index'))
		// test[a]()
		console.log(a)
	}

	renderAppFormMenu = () => {
		let { formConfig } = this.state
		let appFormMenu = formConfig && formConfig.appFormMenu
		if (!appFormMenu) return <Fragment />
		let appFormActionList = appFormMenu.appFormActionList || []
		return <AppFormMenu appFormActionList={appFormActionList} customer={this.customer} />
	}

	render() {
		let { formData, formConfig, tabId } = this.state
		let a = [{ a: 1 }, { b: 2 }]
		console.log('render', { ...a })
		return (
			<AppFormLayoutContext.Provider
				value={{
					formData,
					formConfig,
					onChange: this.onChange,
					tabId,
				}}
			>
				<div className={`app-form-layout ${this.props.className || ''}`} style={this.props.style}>
					{/* <AppLoading /> */}
					{this.renderAppFormTabs()}
					{this.renderAppForm()}
					{this.renderAppFormMenu()}
				</div>
			</AppFormLayoutContext.Provider>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/AppFormLayout/AppFormLayout.tsx